import { getCompanyPatentList } from '@/infrastructure/api-functions';
import { ListBaseService } from '@eureka/solution-card';
import type { ISolutionListResponse } from '@eureka/solution-card/src/types';

export class PatentListService extends ListBaseService {
    protected fetchData(
        data: {
            page: number, limit: number, data?: Record<string, unknown>
        }
    ): Promise<ISolutionListResponse> {
        return getCompanyPatentList(data);
    }
}
